import { Component } from '@angular/core';

@Component({
  selector: 'demo-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
  standalone: false,
})
export class DemoGridComponent {}
